<div class="dropdown-container">
  <label [for]="id()" class="dropdown-label">{{ label() }}</label>
  <select
    [id]="id()"
    (change)="onSelectionChange($event)"
    class="dropdown-select"
    [disabled]="disabled()"
  >
    @for (option of options(); track option.value) {
      <option [value]="option.value" [selected]="option.value === value()">
        {{ option.label }}
      </option>
    }
  </select>
</div>
